import { gql } from '@apollo/client'

import { BRAND_CURATION_TASK_DETAILS_FRAGMENT } from '../fragments'

const BRAND_CURATION_TASK_QUERY = gql`
  query brandCurationTask($id: ID!) {
    brandCurationTask(id: $id) {
      ...BrandCurationTaskDetailsFragment
    }
  }
  ${BRAND_CURATION_TASK_DETAILS_FRAGMENT}
`

export default BRAND_CURATION_TASK_QUERY
